import React, { useState } from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import { card32Players } from "./card32Cards";
import CardImg from "../../../../components/CardImg";

/**
 * 32 Cards video overlay — reference markup (.cards32a / .cards32b):
 * .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container
 *   > (per player with cards) div > .dealer-name.w-100.mb-1 > span[.text-success] "Player N: " + span.text-warning count
 *                                 + div > span > img
 * `variant` "a": rendered whenever there is a card string, hidden while the first card is "1".
 * `variant` "b" (card32eu): hidden while Player 8 has no card.
 */
export default function Card32CardsOverlay({ cardString, variant = "a" }) {
  const [showCards, setShowCards] = useState(true);
  const str = String(cardString ?? "");
  if (!str) return null;
  const firstCard = str.split(",")[0].trim();
  const players = card32Players(str);
  const hidden = variant === "b" ? !showCards || !players[0].cards.length : !showCards || firstCard === "1";
  const dealt = variant === "b" ? players[0].cards.length > 0 : firstCard !== "1";
  if (!dealt && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  const toggle = () => {
    if (variant === "b" || firstCard !== "1") setShowCards((s) => !s);
  };

  return (
    <div className={`casino-video-cards${hidden ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={toggle}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        {players.map((p, i) => {
          if (!p.cards.length) return null;
          const leader = players.every((o) => p.count >= o.count);
          return (
            <React.Fragment key={p.name}>
              {i > 0 && " "}
              <div>
                <div className="dealer-name w-100 mb-1">
                  <span className={leader ? "text-success" : undefined}>{`Player ${p.name}: `}</span>{" "}
                  <span className="text-warning">{p.count}</span>
                </div>{" "}
                <div>
                  {p.cards.map((token, ci) => (
                    <span key={ci}>
                      <CardImg src={getCardImage(token)} />
                    </span>
                  ))}
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
